export const socialEndpoints = (builder) => ({
    syncSocialUser: builder.mutation({
        query: (user) => ({ url: `/social/users`, method: 'post', body: user }),
        invalidatesTags: ['Social'],
    }),
    getSocialUser: builder.query({
        query: (id) => ({ url: `/social/profiles/${id}`, method: 'get' }),
        providesTags: ['Social'],
    }),
    promoteUser: builder.mutation({
        query: ({ userId, ...data }) => ({
          url: `/social/promote-user/${userId}`,
          method: "post",
          body: { ...data }, 
        }),
        invalidatesTags: ["Social"],
      }),
      demoteUser: builder.mutation({
        query: ({ userId, ...data }) => ({
          url: `/social/demote-user/${userId}`,
          method: "post",
          body: { ...data }, 
        }),
        invalidatesTags: ["Social"],
      }),
      
    getSocialUserPosts: builder.query({
        query: (profileId) => ({ url: `/social/profiles/${profileId}/posts`, method: 'get' }),
        providesTags: ['Social'],
    }),
    getPostReplies: builder.query({
        query: ({profileId, postId}) => ({ url: `/social/profiles/${profileId}/posts/${postId}/replies`, method: 'get' }),
        providesTags: ['Social'],
    }),
    setSocialSubscriptionFee: builder.mutation({
        query: ({userId, fee, meta}) => ({url: `/social/users/${userId}/subscription-fee`, method: 'post', body: {fee, meta}}),
        invalidatesTags: ['Social'],
    }),
    getSocialSubscriptionFee: builder.query({
        query: (userId) => ({ url: `/social/users/${userId}/subscription-fee`, method: 'get' }),
        providesTags: ['Social'],
    }),
    suspendUser: builder.mutation({
        query: ({profileId, ...data}) => ({url: `/social/suspend-user/${profileId}`, method: 'post',  body: { ...data } }),
        invalidatesTags: ['Social'],
    }),
    enableUser: builder.mutation({
        query: ({profileId}) => ({url: `/social/unsuspend-user/${profileId}`, method: 'post'}),
        invalidatesTags: ['Social'],
    }),
    approveSocialRequest: builder.mutation({
        query: ({requestId}) => ({url: `/social/approve-social-request/${requestId}`, method: 'post'}),
        invalidatesTags: ['Social'],
    }),
    declineSocialRequest: builder.mutation({
        query: ({requestId, ...data}) => ({url: `/social/decline-social-request/${requestId}`, method: 'post',  body: { ...data }}),
        invalidatesTags: ['Social'],
    }),
    downloadSocialReport: builder.mutation({
        query: ({ file_ext, ...data }) => ({
            url: `/social/report/${file_ext}`,
            method: "post",
            body: data,
            params: data,
            responseType: "blob",
        }),
    }),
    getSocialAnalytics: builder.query({
        query: () => ({ url: `/social/analytics`, method: "get" }),
        providesTags: ["Social"],
    }),
})